import { useContext, useMemo } from 'react';

import { Avatar, getAvatarColor } from '@raystack/apsara';
import { User } from '@raystack/frontier';

import { IdentityContext } from '@src/contexts';
import { getInitials } from '@src/utils';

export const UserAvatar = ({
  userData,
  ...props
}: React.ComponentProps<typeof Avatar> & { userData?: User }) => {
  const { user } = useContext(IdentityContext);
  const currUser = userData?.id ? userData : user;

  const userInitials = useMemo(() => {
    return getInitials(currUser);
  }, [currUser?.name]);

  return (
    <Avatar
      alt={user?.name}
      src={currUser?.avatar}
      fallback={userInitials}
      color={getAvatarColor(currUser?.id || '')}
      {...props}
    />
  );
};
